"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DEBUG_1 = require("@src/DEBUG");
DEBUG_1.DEBUG.open('/init/init.guard.ts');
const router_1 = require("@angular/router");
const rxjs_1 = require("rxjs");
const app_service_1 = require("../commons/app.service");
class InitGuard {
    constructor(service, router) {
        this.service = service;
        this.router = router;
        DEBUG_1.DEBUG.log('/init/init.guard.ts');
    }
    canActivate(route, state) {
        DEBUG_1.DEBUG.log('/init/init.guard.ts', 'canActivate()', { route, state });
        let subject = new rxjs_1.Subject();
        // Check the vasat DB is initialized. Note this is weirdly done as the Back-end responses are not quite well defnied yet
        this.service.V.api("/vadmin/dba/initDB", "get").subscribe(res => {
            //console.log("ENTER init guard res: ",res)
            if (res["db_url"]) {
                this.router.navigate(["init", "db"]);
                subject.next(false);
            }
            else {
                this.checkLicence(subject);
            }
        }, err => {
            DEBUG_1.DEBUG.log('/init/init.guard.ts', 'canActivate() ERROR', { err });
            // Check if error has SyntaxError it is likely the route could not be found or somehow the response was not JSON.
            if (err.status > 6000 && !err.error.toString().includes("SyntaxError")) {
                this.router.navigate(["init", "db"], { queryParams: { status: err.status, msg: err.message } });
                subject.next(false);
            }
            else {
                this.checkLicence(subject);
            }
        });
        return subject;
    }
    checkLicence(subject) {
        this.service.V.api("/access/login/website", "get")
            .subscribe(res => {
            subject.next(true);
        }, err => {
            // This error status means the user has already logged in, therefore licence must be valid
            if (err.status == 4032) {
                subject.next(true);
            }
            else {
                this.router.navigate(["init", "licence"]);
                subject.next(false);
            }
        });
    }
}
exports.InitGuard = InitGuard;
